export const FLOATING_ACTIONS_THRESHOLD = 700;
